export const popupConstant = {
    OPEN_DIALOG: 'POPUP_OPEN_DIALOG',
    CONFIRM_SUCCESS: 'POPUP_CONFIRM_SUCCESS',
    CANCEL: 'POPUP_CANCEL',
};
